import { render, staticRenderFns } from "./DeleteAccountPage.vue?vue&type=template&id=ec57afbc&"
import script from "./DeleteAccountPage.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports